<template>
    <el-form ref="form" :model="formValue" :rules="rules" class="form">
      <el-row>
        <el-col v-for="(item, index) in fields" :span="item.span ? item.span : 12" :key="index">
          <el-form-item v-if="!item.readonly && !item.hidden" :label="item.label + '：'" :prop="item.key" :label-width="labelWidth" :class="{formItemFill: formStyle === 'border', cancelMarginBottom: cancenlMargin}">
            <label v-if="item.type === 'label'">
              {{formValue[item.key]}}
            </label>
            <template v-if="item.type === 'select_custom'">
                <el-select
                filterable
                v-model="formValue[item.key]"
                @change="fieldChange($event, item)"
                :disabled="item.disabled"
                :placeholder="item.placeholder" size="small" style='width:calc(100% - 120px);margin-right:30px'>
                <el-option
                  v-for="(v, i) in item.options"
                  :key="i"
                  :label="v.label"
                  :value="v.value">
                </el-option>
              </el-select>
              <slot :name="item.key" />
            </template>
            <el-input
              v-if="item.type === 'input'"
              v-model="formValue[item.key]"
              size="small" autocomplete="off"
              @change="fieldChange($event, item)"
              :placeholder="item.placeholder"></el-input>
            <el-input
              v-if="item.type === 'password'"
              v-model="formValue[item.key]"
              type="password"
              size="small" autocomplete="off"
              @change="fieldChange($event, item)"
              :placeholder="item.placeholder"></el-input>
            <el-input
              v-if="item.type === 'number'"
              v-model="formValue[item.key]"
              type="number"
              :max="item.max"
              :min="item.min"
              @change="fieldChange($event, item)"
              size="small" autocomplete="off"
              :placeholder="item.placeholder"></el-input>
            <el-input
              v-if="item.type === 'textarea'"
              type="textarea"
              :rows="item.rows || 2"
              :autosize="item.autosize || false"
              v-model="formValue[item.key]"
              size="small" autocomplete="off"
              @change="fieldChange($event, item)"
              :placeholder="item.placeholder"></el-input>
            <!--<el-checkbox-group
              v-if="item.type === 'checkbox'"
              @change="fieldChange($event, item)"
              v-model="formValue[item.key]">
              <el-checkbox
                v-for="(v, i) in item.options"
                :name="item.key"
                :label="v.goods_name"
                :key="i">{{ v.goods_name }}
              </el-checkbox>
            </el-checkbox-group>-->
            <el-select v-if="item.type === 'select'"
              filterable
              v-model="formValue[item.key]"
              @change="fieldChange($event, item)"
              :placeholder="item.placeholder" size="small" style='width: 100%'>
              <el-option
                v-for="(v, i) in item.options"
                :key="i"
                :label="v.label"
                :value="v.value">
              </el-option>
            </el-select>
            <el-radio-group
              class="radioGroup"
              v-if="item.type === 'radio'"
              @change="fieldChange($event, item)"
              v-model="formValue[item.key]">
              <el-radio
                class="radio"
                v-for="(v, i) in item.options"
                :key="i"
                :label="v.value">{{v.label}}
              </el-radio>
            </el-radio-group>
            <el-date-picker
              v-if="item.type === 'date'"
              style="width: 100%"
              v-model="formValue[item.key]"
              type="date"
              size="small"
              :value-format="item.valueFormat"
              @change="fieldChange($event, item)"
              :placeholder="item.placeholder">
            </el-date-picker>
            <el-date-picker
              v-if="item.type === 'daterange'"
              v-model="formValue[item.key]"
              type="daterange"
              size="small"
              style="width: 100%"
              range-separator="~"
              @change="fieldChange($event, item)"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-cascader
              v-if="item.type === 'cascader' && item.options"
              :size="item.size ? item.size : 'small'"
              style="width: 100%"
              v-model="formValue[item.key]"
              :options="item.options"
              @change="fieldChange($event, item)"
              :show-all-levels="item.showAllLevels"
              :props="item.props ? item.props : { checkStrictly: true, children: 'sub', label: 'name', value: 'id' }"
            ></el-cascader>
            <AntdCascader
              v-if="item.type === 'antdCascader'"
              style="width: 100%"
              v-model="formValue[item.key]"
              :options="item.options"
              @change="fieldChange($event, item)"
              :loadData="item.loadData"
              :placeholder="item.placeholder || '请选择'"
              :fieldNames="item.fieldNames || { label: 'label', value: 'value', children: 'children' }"
              changeOnSelect/>
            <UploadImg
              v-if="item.type === 'image'"
              :size="item.size"
              @change="fieldChangeValidate(item.key)"
              v-model="formValue[item.key]"
              :disabled="!!item.disabled"
              :multiple="item.multiple"
              :limit="item.limit || 1"
              :pathType="item.pathType || 'goods'"
              />
          </el-form-item>
          <el-form-item v-else-if="item.readonly && !item.hidden" :label="item.label + '：'" :prop="item.key" :label-width="labelWidth" :class="{formItemFill: formStyle === 'border', cancelMarginBottom: cancenlMargin}">
            <label>
              {{formValue[item.key]}}
            </label>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="btns" v-if="!hiddenBtns">
        <AppButton type="primary" size="medium" @click="submit" :loading="loading" :asyncSubmit="asyncSubmit">提交保存</AppButton>
        <AppButton @click="cancel">取消</AppButton>
      </div>
    </el-form>
</template>

<script>
import { Cascader as AntdCascader } from 'ant-design-vue';
import UploadImg from '../uploadImg/uploadImg.component.vue';
  export default {
    name: 'AppForm',
    components: { UploadImg, AntdCascader },
    data() {
      return {
        formValue: this.defaultValues || {},
        imgVisible: false,
        image: '',
        loading: false,
//        shipping_info: []
      }
    },
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
      rules: {
        type: Object,
        default: () => ({}),
      },
      defaultValues: {
        type: Object,
        default: () => {
          return {};
        },
      },
      formStyle: {
        type: String,
        default: 'border', // 'border' | 'default'
      },
      hiddenBtns: {
        type: Boolean,
        default: false,
      },
      labelWidth: {
        type: String,
        default: '',
      },
      cancenlMargin:{
        type: Boolean,
        default: false
      },
      asyncSubmit: {
        type: Function,
        default: () => {}
      },
    },
    created() {
      // this.updateValues();
    },
    methods: {
      updateValues() {
        this.formValue = JSON.parse(JSON.stringify(this.defaultValues));

      },
      // 部分组件可能需要手动更新校验状态
      fieldChangeValidate(key) {
        this.$refs.form.validateField(key);
        this.$emit('fieldsChange');
      },
      fieldChange($event, item) {
        if (item.change) {
          item.change($event);
        }
        this.$emit('fieldsChange');
      },
      cancel() {
        this.$emit('cancel');
      },
      async submit() {
        const result = await this.$refs.form.validate();
        if (result) {
          const data = Object.assign({}, this.formValue);
          this.$emit('submit', data);
          this.asyncClick(data);
          return Promise.resolve(data);
        } else {
          return Promise.resolve(result);
        }
        
      },
      async asyncClick(result) {
        if (this.asyncSubmit) {
          const req = this.asyncSubmit(result);
          if (req instanceof Promise) {
            this.loading = true;
            await req;
            this.loading = false;
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

.btns {
  display: flex;
  justify-content: flex-end;
  padding: 0 30px;
}
.form {
  padding-bottom: 30px;
  & /deep/ .el-form-item__label {
    width: 100%;
    text-align: left;
  }
  & /deep/ .el-form-item {
    padding: 0 10px;
    min-height: 41px;
    // margin-bottom: 0;
  }
  & /deep/ .el-form-item__content {
    text-align: left;
    min-height: inherit;
  }
  .radioGroup {
    min-height: inherit;
    display: flex;
    width: 100%;
    align-items: center;
  }
  .radio {
    margin-right: 10px;
  }
}
.cancelMarginBottom {
  margin-bottom: 0;
}
</style>